import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import Logo from './components/Logo';
import { color } from '../shared/ui';

const colors = { primary: color.brand };

export default function RegisterSuccess({ navTo }) {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Logo />
      <Container sx={{ maxWidth: 428, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: 4,
            color: colors.primary,
          }}
        >
          Registration Success
        </Typography>
        <Typography sx={{ mb: 4 }}>Your registration was successful.</Typography>
        <Button
          variant="contained"
          onClick={() => navTo('login')}
          sx={{ backgroundColor: colors.primary }}
        >
          Login
        </Button>
      </Container>
    </Box>
  );
}
